module.exports = __webpack_public_path__ + "img/visa.d418161d.png";